var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center p-40"},[_c('el-button',{attrs:{"size":"medium","type":"primary"},on:{"click":_vm.go}},[_vm._v(" 去考试 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }